export default __webpack_public_path__ + "static/achieve-soc2-compliance-saas-growth-d79645226262f5b4b619058ae53a5b58.jpg";